module.exports = __webpack_public_path__ + "static/checkBG.a8d5eb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/checkBG.png
// module id = 835
// module chunks = 20897638506783